import React, { Fragment, useEffect, useState } from 'react';
import moment from 'moment';
import 'moment/locale/es';
import { Patient } from '../../interfaces/Patients';
import { Doctor } from '../../interfaces/Doctors';
import { getDoctorFullName, getNurseFullName, getPatientFullName } from '../../utils/fns';
import { useMainProvider } from '../../context/MainProvider';
import { UserTypes } from '../../interfaces/User';
import { Nurse } from '../../interfaces/Nurses';
import { EstudioPost } from '../../interfaces/Receta';
import PatientData from '../../components/PatientData/PatientData';
import { ExtendedEstudiosIndicados } from '../../interfaces/EstudiosIndicados';

function EstudiosIndicadosPrintableDocument({
  patient,
  doctor,
  values,
  selectedEstudios,
}: {
  patient: Patient;
  doctor: Doctor;
  values: ExtendedEstudiosIndicados;
  selectedEstudios: EstudioPost[];
}): JSX.Element {
  const { user } = useMainProvider();
  const [name, setName] = useState('');

  useEffect(() => {
    if (user && user.initialData) {
      if (user.typeId === UserTypes.PatientType) {
        setName(getPatientFullName(user.initialData as Patient).toUpperCase());
      }
      if (user.typeId === UserTypes.DoctorType) {
        setName(getDoctorFullName(user.initialData as Doctor).toUpperCase());
      }
      if (user.typeId === UserTypes.NurseType) {
        setName(getNurseFullName(user.initialData as Nurse).toUpperCase());
      }
    }
  }, [user, user?.initialData]);

  useEffect(() => {
    moment.locale('es');
  }, [patient]);

  return (
    <table className='table-full-width'>
      <tbody>
        <tr>
          <td>
            <table className='table-full-width'>
              <tbody>
                <tr>
                  <td>
                    <span>
                      <p style={{ textAlign: 'end', fontSize: '10px' }}>
                        <strong>
                          Fecha y Hora de impresión:{' '}
                          {moment().locale('ES').format('DD MMMM YYYY h:mm:ss a')}
                          <br />
                        </strong>
                      </p>

                      <p style={{ textAlign: 'right', fontSize: '10px' }}>
                        <strong>
                          {doctor.med_consultorio?.toUpperCase()}
                          <br />
                          {doctor.med_raz_social?.toUpperCase()},{' '}
                          {doctor.med_no_registro?.toUpperCase()}
                          <br />
                          {doctor.med_domicilio?.toUpperCase()},
                          {doctor.med_colonia_consultorio?.toUpperCase()},{' '}
                          {doctor.med_municipio_consultorio?.toUpperCase()},{' '}
                          {doctor.med_ciudad_consultorio?.toUpperCase()},
                          {doctor.med_cp_consultorio}
                          <br />
                          Tel. {doctor.med_telefono_consultorio}
                        </strong>
                      </p>
                      <br />
                      <p
                        style={{
                          textAlign: 'center',
                          marginBottom: '16px',
                          fontSize: '12px',
                        }}
                      >
                        <strong>Estudios indicados</strong>
                      </p>

                      <p style={{ textAlign: 'start', fontSize: '10px' }}>
                        <strong>
                          Fecha y Hora de elaboración de la Nota:{' '}
                          {moment(values.fecha)
                            .locale('ES')
                            .format('DD MMMM YYYY h:mm:ss a')}
                        </strong>
                      </p>

                      <p style={{ textAlign: 'start', fontSize: '10px' }}>
                        <PatientData patientInformation={patient} forceDesktop />
                      </p>
                    </span>

                    {selectedEstudios.length > 0 ? (
                      <div
                        className='receta-data-container'
                        style={{ marginBottom: '1rem' }}
                      >
                        <p className='general-p'>
                          <b>Estudios de gabinete</b>
                        </p>
                        {selectedEstudios.map((estudio) => (
                          <Fragment key={estudio.id_estudio}>
                            <p className='general-p'>{estudio.nombre}</p>
                          </Fragment>
                        ))}
                      </div>
                    ) : null}

                    {values.estudios_fuera_cuadro ? (
                      <>
                        <p className='general-p'>
                          <b>Estudios fuera del catálogo médico</b>
                        </p>
                        <p className='general-p' style={{ marginBottom: '1rem' }}>
                          {values.estudios_fuera_cuadro}
                        </p>
                      </>
                    ) : null}

                    <p className='general-p' style={{ marginTop: '1rem' }}>
                      <span style={{ textTransform: 'capitalize' }}>
                        {doctor.med_nombre} {doctor.med_apellidop} {doctor.med_apellidom}
                      </span>
                    </p>
                    <p className='general-p'>
                      <span style={{ textTransform: 'capitalize' }}>
                        Nombre y firma del médico que elaboró la nota:
                        ____________________________________________
                      </span>
                    </p>
                    <p className='general-p'>
                      <span style={{ textTransform: 'capitalize' }}>
                        Especialidad: {doctor.med_especialidad?.cat_especialidad_desc}
                      </span>
                    </p>
                    <p className='general-p'>
                      <span style={{ textTransform: 'capitalize' }}>
                        Cédula: {doctor.med_cedula_profesional}{' '}
                        {doctor.med_institucion_expedio_cedula}
                      </span>
                    </p>

                    {doctor.med_especialidad_id !== 37 ? (
                      <>
                        <p className='general-p'>
                          <span style={{ textTransform: 'capitalize' }}>
                            Cédula especialidad: {doctor.med_cedula_especialidad}{' '}
                            {doctor.med_institucion_expidio_cedula_esp}
                          </span>
                        </p>
                      </>
                    ) : null}

                    <p className='general-p' style={{ textTransform: 'none' }}>
                      <strong>
                        Aviso de privacidad
                        <br />
                      </strong>
                    </p>
                    <p className='general-p' style={{ textTransform: 'none' }}>
                      Para ver nuestro Aviso de privacidad favor consultar:
                      http://zivot.com.mx/aviso-privacidad
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default EstudiosIndicadosPrintableDocument;
